import { article, IArticle } from '../services/article';
import createSliceState from './common/createSliceState';
// todo import { history } from '../utils/history';
import { AdvancedType, BasicType, BlockManager, IBlockData } from '../../core';
import { IEmailTemplate } from '../../editor';
import services from '../services';

export function getAdaptor(data: IArticle): IEmailTemplate {
    const content = JSON.parse(data.json) as IBlockData;
    return {
        ...data,
        content,
        subject: data.subject,
        subTitle: data.subTitle,
    };
}

export default createSliceState({
    name: 'template',
    initialState: null as IEmailTemplate | null,
    reducers: {
        set: (state, action) => {
            return action.payload;
        },
    },
    effects: {
        fetchById: async (
            state,
            {
                id,
            }: {
                id: number;
            },
        ) => {
            try {

                let data = await article.getArticle(id);

                return getAdaptor(data);
            } catch (error) {
                // todo history.replace('/');
                throw error;
            }
        }, updateById: async (
            state,
            payload: {
                id: number;
                template: IEmailTemplate;
                success: (templateId: number) => void;
                error: (templateId: number) => void;
                json: string;
                mjmlString: string;
                html: string;
                previewImage: string;
            },
        ) => {
            try {
                await services.article.updateArticle(Number(payload.id), {
                    subject: payload.template.subject,
                    subtitle: payload.template.subTitle,
                    json: payload.json,
                    mjml: payload.mjmlString,
                    html: payload.html,
                    previewImage: payload.previewImage
                });
                payload.success(payload.id);
                let data = await article.getArticle(payload.id);

                return getAdaptor(data);
            } catch (error: any) {
                payload.error(payload.id);
            }
        },
        fetchDefaultTemplate: async state => {
            return {
                subject: 'Welcome',
                subTitle: 'Nice to meet you!',
                content: BlockManager.getBlockByType(BasicType.PAGE).create({
                    children: [BlockManager.getBlockByType(AdvancedType.WRAPPER).create()],
                }),
            } as IEmailTemplate;
        },
    },
});
